import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-patient-details',
  standalone: true,
  imports: [CommonModule, AdminHeader, AdminSidebar, FormsModule],
  templateUrl: './patient-details.html',
  styleUrls: ['./patient-details.css']
})
export class PatientDetailsComponent implements OnInit {
  baseUrl = 'https://logs.proofile.com.ng/api';
  patient: any = null;
  wardName: string = '';
  issues: any[] = [];
  filteredIssues: any[] = [];

  startDate: string = '';
  endDate: string = '';
  drugSearchTerm: string = '';
  storeSearchTerm: string = '';

  constructor(private http: HttpClient, private route: ActivatedRoute) {}

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    console.log(id);
    this.loadPatient(id);
  }

  loadPatient(id: number) {
    this.http.get(`${this.baseUrl}/patients/${id}`).subscribe((data: any) => {
      this.patient = data;

      if (this.patient.type === 'in-patient' && this.patient.ward_id) {
        this.fetchWardName(this.patient.ward_id);
      }

      this.fetchIssuedDrugs();
    });
  }

  fetchWardName(wardId: number) {
    this.http.get<any>(`${this.baseUrl}/wards/${wardId}`).subscribe(data => {
      this.wardName = data.name;
    });
  }

  fetchIssuedDrugs() {
    if (!this.patient) return;

    const params: any = {
      patient_id: this.patient.id,
      patient_type: this.patient.type
    };

    this.http.get<any[]>(`${this.baseUrl}/product-issues`, { params }).subscribe(data => {
      this.issues = data;
      console.log(this.issues);
      this.applyFilters(); // apply local filtering
    });
  }

  applyFilters() {
    const drugTerm = this.drugSearchTerm.toLowerCase();
    const storeTerm = this.storeSearchTerm.toLowerCase();

    this.filteredIssues = this.issues.filter(issue => {
      const date = new Date(issue.created_at);
      const inDateRange =
        (!this.startDate || date >= new Date(this.startDate)) &&
        (!this.endDate || date <= new Date(this.endDate));

      const matchesDrug = issue.stock_item_name?.toLowerCase().includes(drugTerm);
      const matchesStore = issue.store_name?.toLowerCase().includes(storeTerm);

      return matchesDrug && matchesStore && inDateRange;
    });
  }
}
